import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody42';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy42 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Subsequent Closing Deck </h2><h4>for a multi-strategy private equity fund</h4>";

  return (
    <>
        <Helmet>
        <title>Subsequent Closing Deck for a multi-strategy private equity fund</title>
        <meta property="og:title" content="Subsequent Closing Deck for a multi-strategy private equity fund" />
        <meta property='og:description' content='Subsequent Closing Deck for a multi-strategy private equity fund'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy42" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy42
